import React, {useEffect} from 'react';
import {useRouteMatch} from 'react-router';
import PropTypes from "prop-types";
import {shallowEqual, useSelector} from 'react-redux';
import AbstractModalView from '../AbstractModalView';
import ModalSendPDFDraft from '../../../modules/Inspection/components/Form_11/ModalSendPDFDraft';
import preview from '../../assets/search-4A4A4A.svg'
import {pathnames as P} from '../../constants/pathnames';
import {versions as V} from '../../constants/versions';
import {windowMessages as M} from '../../../modules/Inspection/constants/windowMessages';
import {userTypeIds as USER_TYPE} from "../../constants/userTypeIds";
import styles from './styles.module.scss';

const ModalContent = ({
                        documentPath,
                        closeModal,
                        handleReject
                      }) => {
  useEffect(() => {
    window.addEventListener('message', evt => {
      if (evt.data === M.CLOSE_PREVIEW) {
        closeModal();
      }
    });
  }, []);

  return (
    <div className={styles.modalContentContainer}>
      <div className={styles.documentViewPort}>
        <div className={styles.iframeContainerWrapper}>
          <div className={styles.iframeContainer}>
            <iframe
              src={documentPath}
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
              title="complete inspection document"
              className={styles.iframe}
            >
              <p>
                <a href={documentPath}>
                  Fallback link for browsers that don't support iframes
                </a>
              </p>
            </iframe>
          </div>
        </div>
      </div>

      <div className={styles.modalButtons}>
        <ModalSendPDFDraft buttonClassName={styles.buttonSendEmail}/>
        <button
          type="button"
          className={styles.buttonCancel}
          onClick={handleReject(closeModal)}
        >
          <span>סגירה</span>
        </button>
      </div>
    </div>
  );
};

const ModalPreviewDocument = ({
                                accessToken,
                                submitOnOpen = () => {}
                              }) => {
  const {params: {shumaId, formId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);
  const currentUserID = useSelector(state => state.user.userId, shallowEqual);
  const responsibleUserID = useSelector(state => state.stepStatus.stepStatus.userID, shallowEqual);
  const {adminPermissionsLevel, userTypeID} = useSelector(state => state.user, shallowEqual);
  const generatePath = (url, {accessToken, shumaId, version}) => {
    const qs = new URLSearchParams();
    qs.set('accessToken', accessToken);
    qs.set('shumaID', shumaId);
    qs.set('version', version);

    return `${url}?${qs.toString()}`;
  };

  const documentPath = generatePath(P.COMPLETE_INSPECTION, {
    accessToken,
    shumaId,
    version: V.OFFICIAL
  });

  const handleReject = close => () => {
    close();
  };

  const lastStep = formId === '11';

  return (
    <AbstractModalView
      subPath={'preview'}
      modalClassName={styles.modal}
      triggerContent={({openModal}) => {
        return (
          <div className={lastStep ? styles.lastStepContainer : styles.stepsContainer}>
            <button
              className={lastStep ? styles.buttonPreview : styles.iconPreview}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                openModal();
                if (!lastStep) {
                  submitOnOpen();
                }
              }}
              disabled={!((userTypeID === USER_TYPE.ADMIN && adminPermissionsLevel === 2) || currentUserID === responsibleUserID)}
            >
              {lastStep
                ? <span>תצוגה מקדימה</span>
                : <img src={preview} alt="preview" className={styles.icon}/>
              }
            </button>
          </div>
        )
      }}
      modalContent={({closeModal}) => (
        <ModalContent
          closeModal={closeModal}
          documentPath={documentPath}
          handleReject={handleReject}
        />
      )}
    />
  );
};

ModalPreviewDocument.propTypes = {
  accessToken: PropTypes.string,
  submitOnOpen: PropTypes.func,
};

export default ModalPreviewDocument;
